import { Component, DoCheck, input, model, output } from '@angular/core';
import { Order } from '../shared/classes/order';
import { OrderStatus } from '../shared/classes/order-status.enum';
import { View } from '../shared/classes/view.enum';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    imports: [NgClass, NgStyle]
})
/**
 * The dashboard shown on the left side which allows user to navigate the site.
 */
export class DashboardComponent implements DoCheck {
    /** orders: the user's orders array */
    public readonly orders = input.required<Order[]>();
    /** selectedOrder: the order that should be highlighted as selected */
    public readonly selectedOrder = model<Order | null>(null);
    public readonly viewChange = output<View>();

    /** showOrdersInProgress: whether orders in-progress should be listed in dropdown */
    public showOrdersInProgress = true;
    /** showSubmittedOrders: whether submitted orders should be listed in dropdown */
    public showSubmittedOrders = true;

    /** ordersInProgress: the orders in the user's orders array with In-Progress status */
    public ordersInProgress: Order[] = [];
    /** submittedOrders: the orders in the user's orders array with Submitted status */
    public submittedOrders: Order[] = [];

    /**
     * Filters out the orders that should be shown under In-Progress and
     * submitted and sorts them.
     */
    // This is running much more often than needed
    ngDoCheck(): void {
        const orders = this.orders();
        if (orders) {
            this.ordersInProgress = orders
                .filter((value) => {
                    return value.status === OrderStatus.INPROGRESS;
                })
                .sort((a: Order, b: Order) => {
                    return a.startedDate.getTime() - b.startedDate.getTime();
                });
            this.submittedOrders = orders
                .filter((value) => {
                    return value.status === OrderStatus.SUBMITTED;
                })
                .sort((a: Order, b: Order) => {
                    return a.submissionDate.getTime() - b.submissionDate.getTime();
                });
        }
    }

    /**
     * Toggles whether in-progress orders should be viewed in dropdown.
     */
    toggleOrdersInProgress(): void {
        this.showOrdersInProgress = !this.showOrdersInProgress;
    }

    /**
     * Toggles whether submitted orders should be viewed in dropdown.
     */
    toggleSubmittedOrders(): void {
        this.showSubmittedOrders = !this.showSubmittedOrders;
    }

    /**
     * Changes which order should be viewed in the Existing Order Component and
     * switches to that view.
     *
     * @param order The order that should be switched to.
     */
    selectOrder(order: Order): void {
        this.selectedOrder.set(order);
        this.switchToOrderView();
    }

    /**
     * Changes the form view to the Existing Order Component.
     */
    switchToOrderView(): void {
        this.viewChange.emit(View.ORDER);
    }

    /**
     * Changes the form view to the Account Component.
     */
    switchToAccountView(): void {
        this.viewChange.emit(View.ACCOUNT);
    }

    /**
     * Changes the form view to the Home Component.
     */
    switchToHomeView(): void {
        this.viewChange.emit(View.HOME);
    }

    testing(): void {
        console.log(this.orders());
    }
}
